import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import _ from 'lodash';
import { useMemo, useState } from 'react';
import { propArrayShape, propBool } from '../../../../helpers/custom-prop-types';
import RawSelect2Fields from '../../../Ui/Common/Fields/Select2Fields/RawSelect2Fields';
import AboutRowListWrapper from '../../../Ui/Professional/About/AboutRowListWrapper';
import SectionProjectOne from './SectionProjectOne';
const SectionProject = (props) => {
    const { isBlur, projects } = props;
    const defaultFilter = useMemo(() => ({
        color: '#485C60',
        label: 'ALL',
        value: '',
    }), []);
    const [filter, onChangeFilter] = useState(defaultFilter);
    const viewProjects = useMemo(() => projects.filter((p) => {
        if (filter.value) {
            return !!_.find(p.middleTasks, (middle) => middle.id === parseInt(filter.value, 10));
        }
        return true;
    }), [filter, projects]);
    const values = useMemo(() => {
        const rawValues = _.flattenDeep(projects.map((project) => project.middleTasks));
        const setValues = _.unionBy(rawValues, 'id').map((v) => ({
            color: '#485C60',
            label: v.name,
            value: v.id,
        }));
        return [defaultFilter, ...setValues];
    }, [projects, defaultFilter]);
    return (_jsxs("div", Object.assign({ className: 'about-consultant-project' }, { children: [_jsx("div", Object.assign({ className: 'input-form-react-select' }, { children: _jsx(RawSelect2Fields, { blurInputOnSelect: true, defaultValue: filter, isDisabled: isBlur, isMulti: false, isSearchable: false, name: 'about-filter', onChange: onChangeFilter, options: values, placeholder: '' }) })), _jsx(AboutRowListWrapper, Object.assign({ buttonClassName: 'is-consultant', className: 'projects', maxCount: 2, name: 'projects', rows: viewProjects }, { children: _jsx(SectionProjectOne, { isBlur: isBlur }) })), _jsx(AboutRowListWrapper, Object.assign({ buttonClassName: 'is-consultant', className: 'projects', minCount: 2, name: 'projects', rows: viewProjects }, { children: _jsx(SectionProjectOne, { isBlur: isBlur }) }))] })));
};
SectionProject.propTypes = {
    isBlur: propBool().isRequired,
    projects: propArrayShape().isRequired,
};
export default SectionProject;
